import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getagent } from '../redux/agent';
import Progress from '../components/Loader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal(props) {
  const list = props.chosen;
  const [open, setOpen] = React.useState(props.value);
  const [category, setcategory] = React.useState("none");
  const [businesstype, setbusinesstype] = React.useState("none");
  const [gender, setgender] = React.useState("none");
  const [loading, setloading] = React.useState(false);
  const [personName, setPersonName] = React.useState([]);
  const [checked, setchecked] = React.useState(props.chosen.permission ? props.chosen.permission : []);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const dispatch = useDispatch();

  const names = [
    "Crops",
    "Seeds",
    "Fertilizers",
    "Machinery",
    "Irrigation"
  ];

  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };

  const clearForm = () => {
    document.getElementById("descriptionapp").value = "";
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const addapp = async (e) => {
    e.preventDefault();
    setloading(true);
    try {
      const res = await axios.post("https://embert.sisrevolution.com/api/expenses/addexpenses/", {
        description: document.getElementById("descriptionapp").value,
        id: list.id,
        status: "Approved"
      });
      if (res.status === 200) {
        setloading(false);
        dispatch({ type: 'expenses/getexpenses', payload: { data: res.data } });
        setSnackbarMessage('Expense approved successfully!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        clearForm();
        handleClose();
      } else {
        setloading(false);
        setSnackbarMessage('Failed to approve expense.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setloading(false);
      setSnackbarMessage('An error occurred while approving expense.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const deleter = async () => {
    setloading(true);
    try {
      const res = await axios.post("https://embert.sisrevolution.com/api/agent/editagent/", {
        _id: props.chosen.id,
        permissions: checked
      });
      if (res.status === 200) {
        setloading(false);
        dispatch(getagent({ data: res.data } ));
        setSnackbarMessage('Agent permissions updated successfully!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        handleClose();
      } else {
        setloading(false);
        setSnackbarMessage('Failed to update agent permissions.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setloading(false);
      setSnackbarMessage('An error occurred while updating agent permissions.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleCheck = (event) => {
    const value = event.target.checked;
    let lister = [];
    if (value) {
      lister = [...checked, event.target.value];
    } else {
      lister = checked.filter((bug) => bug !== event.target.value);
    }
    setchecked(lister);
  };

  return (
    <div>
      <Dialog fullWidth minWidth="sm" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Approve
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box>
            <form onSubmit={addapp}>
              <TextField
                id="descriptionapp"
                required
                label="Description"
                type="text"
                style={{ width: "98%", marginTop: "15px" }}
                autoComplete="current-text"
              />
              <br />
              <br />
              <div style={{ marginTop: 2, textAlign: "center", width: "100%" }}>
                {loading ? (
                  <Button variant="outlined" startIcon={<Progress />} disabled>
                    Loading...
                  </Button>
                ) : (
                  <Button type="submit" variant="outlined" size="large">
                    Approve
                  </Button>
                )}
              </div>
            </form>
          </Box>
        </DialogContent>
        
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}